'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { setCookie } from 'cookies-next/client';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Button as AriaButton, DialogTrigger } from 'react-aria-components';
import ListingMessageModal from '@/features/listing/components/listing-message-modal/listing-message-modal';
import { type ListingDataView, type ListingWithUser } from '@/features/listing/types/listing-types';
import useAppFlyerLink from '@/features/roomster-app/hooks/use-app-flyer-link';
import { loggedUserAtom } from '@/features/user/atoms/logged-user-atom';
import { useRouter } from '@/i18n/routing';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import { SECONDS } from '@/shared/constants/time-constants';
import { type MessageSentSource } from '@/shared/types/report-types';
import Button from '@/ui/button/button';
import buttonStyles from '@/ui/button/button.module.scss';
import Modal from '@/ui/modal/modal';
interface ListingMessageProps {
  listing: ListingWithUser;
  view?: ListingDataView;
  messageSrc?: MessageSentSource;
}
export default function ListingMessageButton(props) {
  const $ = _c(15);
  const {
    listing,
    messageSrc,
    view: t0
  } = props;
  const view = t0 === undefined ? "isCard" : t0;
  const translationsListingCard = useTranslations("listing.card");
  const router = useRouter();
  const loggedUser = useAtomValue(loggedUserAtom);
  const appFlyerLinkName = view === "isCard" ? "mobileMessageButton" : "mobileListingMessageButton";
  const appFlyerLink = useAppFlyerLink("mobile", appFlyerLinkName, ROUTER_LINKS.phoneAuth);
  const [isModalActive, setIsModalActive] = useState(false);
  let t1;
  if ($[0] !== loggedUser || $[1] !== router) {
    t1 = () => {
      if (!loggedUser) {
        router.push(ROUTER_LINKS.phoneAuth);
        return;
      }
      if (!loggedUser.isVerified) {
        router.push(ROUTER_LINKS.accountValidation);
        return;
      }
      setIsModalActive(true);
    };
    $[0] = loggedUser;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOnMessageClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsModalActive(false);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const closeMessageModal = t2;
  let t3;
  if ($[4] !== listing.user.firstName) {
    t3 = () => {
      setCookie("authData", JSON.stringify({
        token: "send-message",
        userName: listing.user.firstName
      }), {
        maxAge: SECONDS.HOUR,
        path: "/"
      });
    };
    $[4] = listing.user.firstName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleMessageAuthData = t3;
  let t4;
  if ($[6] !== appFlyerLink || $[7] !== handleMessageAuthData || $[8] !== handleOnMessageClick || $[9] !== isModalActive || $[10] !== listing || $[11] !== loggedUser || $[12] !== messageSrc || $[13] !== translationsListingCard) {
    t4 = loggedUser ? <DialogTrigger><AriaButton className={cx(buttonStyles.base, buttonStyles.size_md, buttonStyles.variant_filled, buttonStyles.shade_dark, buttonStyles.size_full, buttonStyles.font_xs)} onPressUp={handleOnMessageClick}>{translationsListingCard("message")}</AriaButton><Modal isOpen={isModalActive} onOpenChange={setIsModalActive} isCloseOnClickOutside={true} showCloseIcon={true} positionMobile="top"><ListingMessageModal listing={listing} onClose={closeMessageModal} messageSrc={messageSrc} /></Modal></DialogTrigger> : <Button element="link" onClick={handleMessageAuthData} href={appFlyerLink} size="md" fontSize="xs" fullWidth={true}>{translationsListingCard("message")}</Button>;
    $[6] = appFlyerLink;
    $[7] = handleMessageAuthData;
    $[8] = handleOnMessageClick;
    $[9] = isModalActive;
    $[10] = listing;
    $[11] = loggedUser;
    $[12] = messageSrc;
    $[13] = translationsListingCard;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}